// Depois de um deploy, a aba que ficou aberta continua com o bundle antigo, e o primeiro import dinâmico
// (uma tela que não estava carregada, o editor de flow, o Monaco) pede um chunk com o hash velho, que o
// servidor já não tem. O Vite avisa pelo evento `vite:preloadError` e o router recusa a navegação com
// "Failed to fetch dynamically imported module". Recarregar a página traz o bundle novo.
//
// Uma vez só: a marca em `sessionStorage` diz quando foi a última recarga, e dentro de 60 s o erro só é
// registrado, para um chunk que falta de verdade não virar laço de recarga. Sem `sessionStorage` (navegação
// privada, cota cheia) não há como marcar, e então também não recarrega.
const MARCA = 'powerbizz:recarga-por-chunk-velho';
export const JANELA_MS = 60 * 1000;

// Chrome, Firefox e Safari dizem a mesma coisa de três jeitos.
const MENSAGENS_DE_CHUNK = [
  'Failed to fetch dynamically imported module',
  'error loading dynamically imported module',
  'Importing a module script failed',
];

export const ehChunkVelho = erro => {
  const texto = String(erro?.message ?? erro ?? '');
  return MENSAGENS_DE_CHUNK.some(mensagem => texto.includes(mensagem));
};

function marcarRecarga(janela, agora) {
  try {
    const ultima = Number(janela.sessionStorage.getItem(MARCA));
    if (ultima && agora - ultima < JANELA_MS) return false;
    janela.sessionStorage.setItem(MARCA, String(agora));
    return true;
  } catch (e) {
    return false;
  }
}

// Recarrega (indo a `destino`, quando o erro veio de uma navegação) e diz se recarregou.
export function recarregarUmaVez(
  erro,
  { janela = window, agora = Date.now(), destino = null } = {}
) {
  if (!marcarRecarga(janela, agora)) {
    // eslint-disable-next-line no-console
    console.error(
      '[chunk velho] não recarrego de novo: já recarreguei há menos de 60 s, ou não há onde marcar',
      erro
    );
    return false;
  }
  if (destino) janela.location.assign(destino);
  else janela.location.reload();
  return true;
}

// No ponto de entrada do painel. O `preventDefault` só quando recarrega: sem recarga, o erro segue para
// quem fez o import, como antes.
export function instalarRecargaDeChunkVelho({ janela = window, router } = {}) {
  janela.addEventListener('vite:preloadError', evento => {
    if (recarregarUmaVez(evento.payload, { janela })) evento.preventDefault();
  });
  router?.onError((erro, para) => {
    if (ehChunkVelho(erro)) {
      recarregarUmaVez(erro, { janela, destino: para?.fullPath || null });
    }
  });
}
